module.exports = __webpack_public_path__ + "img/Icon-X.af36e119.svg";